export const selectIsSomethingLoading = (state) =>
  state.client.didInvalidate ||
  state.portfolios.didInvalidate ||
  // state.transactions.didInvalidate || // TODO: make a similar function for the effector store
  state.questionnaire.didInvalidate ||
  state.ui.didInvalidate
